<template>
  <div class="">
    <div class="app-load-container" v-if='!initialLoad'>
      <div class="app-load-box">
        <h2>Loading Dashboard...</h2>
        <Spinner class='app-load' />
      </div>
    </div>
    <div class="" v-else>
      <div v-if='notify && notify.msg' :class='{"top-alert": true, error: notify.error, "slide-away": notify.slideAway}'>
        <h1>{{notify.msg}}</h1>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  computed: {
    initialLoad() {
      return this.$store.state.initialLoad
    },
    notify() {
      return this.state.notify
    },
  },
  created() {
  }
}
</script>

<style>
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>

<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
  .app-load {
    font-size: 48px !important;
    color: #b3b3b3;
  }
  .app-load-container {
    margin-top: 20%;
    display: flex;
  }
  .app-load-box {
    margin: 0 auto;
    text-align: center;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #f5f5f5;
  }
</style>

<style scoped>
.top-alert {
  position: fixed;
  top: 5px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 999999;
}
.top-alert > h1 {
  background: #e2ffdc;
  padding: 8px 67px;
  font-size: 18px;
  color: #105800;
  min-width: 444px;
  text-align: center;
  border: 1px solid #d8dcd7;
  animation-name: example;
  animation-duration: 0.4s;
  height: 40px;
}
.top-alert.slide-away > h1 {
  animation-name: example2;
  animation-duration: 1s;
  transform: translateY(-45px);
}
.top-alert.error > h1 {
  background: #f4d3d3;
  color: #834747;
  border: 1px solid #cba5a5;
}

@keyframes example {
    from {
      transform: translateY(-45px);
    }
    to {
      transform: translateY(0);
    }
}


@keyframes example2 {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-45px);
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue